import '../App.css';
import './V2Warning.css';

function V2Warning({ title }) {
    return (
        <div
            className='v2-warning'
            style={{ fontSize: '1.2em' }}
        >
            <i
                className="pi pi-exclamation-triangle"
            />
            <div style={{ marginLeft: '0.4em' }}>
                {title}
            </div>
        </div>
    );
}

export default V2Warning;